import { createFileRoute } from '@tanstack/react-router';
import { AdminTailgateCostPage } from '@/features/admin/admin-tailgate-cost-page';

export const Route = createFileRoute('/admin/tailgate-cost')({
  component: AdminTailgateCostRoute,
});

function AdminTailgateCostRoute() {
  return <AdminTailgateCostPage />;
}
